/**
 * FetchLocationList pulls out the array of state/city/neighborhood from the locationOptions
 * @param {Array} locationOptions, an array containing all the locationOptions
 * @param {Object} listObject, the object containing the array for this lcoation
 * @returns {Array} locationList, the array containing all the locations of this type(city, state etc.)
 */
export const FetchLocationList = (locationOptions, listObject) => {
  let locationList = []
  if (
    locationOptions &&
    locationOptions.length > 0 &&
    listObject &&
    listObject.list &&
    listObject.list.length > 0
  ) {
    locationList = listObject.list
  }
  return locationList
}

export const GetSelectedLocation = (locations) =>
  locations.find((location) => location.isSelected === true) || null
